export default [
  {
    action: 'user',
    label: 'Assign to me',
  },
  {
    action: 'editor',
    label: 'Assign to Editors Queue',
  },
  {
    action: 'partnership_manager',
    label: 'Assign to Managers Queue',
  },
  {
    action: 'accept',
    label: 'Accept',
    isManage: true,
  },
  {
    action: 'deny',
    label: 'Deny with Comment',
    isManage: true,
  },
];
